import React from "react";
import { Button } from "react-bootstrap";
import WarningModal from "../WarningModal";

const NotificationPopUpMapper = ({
  showModal,
  DeleteToastMessage,
  DeleteToastMessageHead,
  handleCancelClick,
}) => {
  return (
    <WarningModal
      show={showModal}
      onHide={handleCancelClick}
      DeleteToastMessage={DeleteToastMessage}
      DeleteToastMessageHead={DeleteToastMessageHead}
    >
      <div className="msg-headtext">
        <h4 style={{ paddingRight: "50px" }}>{DeleteToastMessageHead}</h4>
        <div style={{ marginBottom: "10px" }}>
          <p>{DeleteToastMessage} </p>
          <p style={{ marginTop: "5px", marginBottom: "10px" }}></p>
        </div>

        <div className="btnsDeleteCancelMapper">
          <Button
            className="removeButtonWarningMapper"
            onClick={handleCancelClick}
          >
            OK
          </Button>
        </div>
      </div>
    </WarningModal>
  );
};

export default NotificationPopUpMapper;
